import { Component, HostBinding, Input } from "@angular/core";

@Component({
  selector: "ta-box",
  template: `
    <ng-content></ng-content>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `
  ]
})
export class BoxComponent {
  @HostBinding("style.padding")
  @Input()
  padding: string | undefined;

  @HostBinding("style.margin")
  @Input()
  margin: string | undefined;

  @HostBinding("style.border")
  @Input()
  border: string | undefined;

  @HostBinding("style.width")
  @Input()
  width: string | undefined;

  @HostBinding("style.background-color")
  @Input()
  backgroundColor: string | undefined;
}
